import { LIMA_DISTRICTS } from '@performance-crm/shared';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/** Distrito donde vive el cliente: se guarda en el contacto y alimenta el perfil del comprador. */
export function ContactDistrictField({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="space-y-1">
      <Label htmlFor={id}>Distrito del cliente</Label>
      <Input
        id={id}
        list="lima-districts"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Donde vive (p. ej. Miraflores)"
        maxLength={80}
        autoComplete="off"
      />
      <datalist id="lima-districts">
        {LIMA_DISTRICTS.map((d) => (
          <option key={d} value={d} />
        ))}
      </datalist>
      <p className="text-muted-foreground text-xs">
        Se guarda en los datos del cliente y alimenta el perfil del comprador.
      </p>
    </div>
  );
}
